// extracted by mini-css-extract-plugin
export default {"details_big_banner":"style_details_big_banner__STr-q","details_big_banner_loader":"style_details_big_banner_loader__yNRCS"};